// Telegram message content

// Demo messages - sequence of user messages for the auto demo
export const demoMessages = [
  "What's the weather forecast for Moscow this week?",
  "Send me the latest news about cryptocurrency",
  "I need a cab to the airport tomorrow at 10am",
  "Translate 'hello, how are you?' to Russian",
  "Show me nearby restaurants with good reviews"
];

// Predefined tool responses for each demo message
export const demoResponses: Record<string, {tool: string, input: any, output: any}> = {
  "What's the weather forecast for Moscow this week?": {
    tool: 'weather_forecast',
    input: { 
      location: "Moscow", 
      days: 7
    },
    output: { 
      location: "Moscow, Russia",
      forecast: [
        { day: "Monday", condition: "Partly Cloudy", high: 12, low: 4, precipitation: "20%" },
        { day: "Tuesday", condition: "Sunny", high: 15, low: 6, precipitation: "0%" },
        { day: "Wednesday", condition: "Sunny", high: 17, low: 7, precipitation: "0%" },
        { day: "Thursday", condition: "Cloudy", high: 14, low: 8, precipitation: "30%" },
        { day: "Friday", condition: "Rain", high: 10, low: 5, precipitation: "80%" },
        { day: "Saturday", condition: "Rain", high: 9, low: 4, precipitation: "70%" },
        { day: "Sunday", condition: "Partly Cloudy", high: 11, low: 3, precipitation: "20%" }
      ],
      units: "celsius",
      updated: "2024-04-17T08:30:00Z",
      weatherMapUrl: "https://weather.example.com/moscow/map",
      hourlyForecastUrl: "https://weather.example.com/moscow/hourly",
      alertsUrl: "https://weather.example.com/moscow/alerts"
    }
  },
  "Send me the latest news about cryptocurrency": {
    tool: 'news_search',
    input: { 
      query: "cryptocurrency", 
      sort: "recent",
      count: 5
    },
    output: { 
      articles: [
        { title: "Bitcoin Surges Past $70,000 in Market Rally", source: "CryptoDaily", published: "Today, 6:45 AM", url: "https://cryptodaily.example.com/bitcoin-surge" }, 
        { title: "New Regulations Impact Cryptocurrency Exchanges", source: "Financial Times", published: "Today, 5:30 AM", url: "https://ft.example.com/crypto-regulations" },
        { title: "Major Bank Launches Cryptocurrency Trading Platform", source: "Bloomberg", published: "Yesterday", url: "https://bloomberg.example.com/bank-crypto" },
        { title: "Ethereum Update: What Investors Need to Know", source: "CoinDesk", published: "Yesterday", url: "https://coindesk.example.com/ethereum-update" },
        { title: "NFT Market Shows Signs of Recovery After Slump", source: "Reuters", published: "2 days ago", url: "https://reuters.example.com/nft-recovery" }
      ],
      query: "cryptocurrency",
      total_results: 1254,
      language: "en",
      trendingUrl: "https://news.example.com/trending/crypto",
      marketDataUrl: "https://markets.example.com/crypto/live",
      alertSetupUrl: "https://alerts.example.com/setup/crypto"
    }
  },
  "I need a cab to the airport tomorrow at 10am": {
    tool: 'taxi_booking',
    input: { 
      pickup: "current_location",
      destination: "airport", 
      time: "tomorrow 10:00 AM",
      passengers: 1
    },
    output: { 
      booking_id: "TX-85429",
      service: "TelegramTaxi",
      car_type: "Comfort",
      estimated_price: "1200-1500 RUB",
      pickup_time: "2024-04-18T10:00:00",
      pickup_location: "Saved Home Address",
      destination: "Sheremetyevo International Airport (SVO)",
      estimated_travel_time: "45 min",
      driver_info: {
        arriving_time: "Arriving on time",
        rating: 4.8
      },
      status: "confirmed",
      trackingUrl: "https://telegramtaxi.example.com/track/TX-85429",
      cancelUrl: "https://telegramtaxi.example.com/cancel/TX-85429",
      airportInfoUrl: "https://airport.example.com/SVO/departures"
    }
  },
  "Translate 'hello, how are you?' to Russian": {
    tool: 'translator',
    input: { 
      text: "hello, how are you?", 
      source_language: "English",
      target_language: "Russian" 
    },
    output: { 
      translated_text: "привет, как дела?",
      source_language: "en",
      target_language: "ru",
      phonetic: "privet, kak dela?",
      alternates: [
        "привет, как ты?",
        "здравствуйте, как у вас дела?"
      ],
      formality: "informal",
      pronunciationUrl: "https://translate.example.com/pronounce/ru/привет-как-дела",
      dictionaryUrl: "https://dictionary.example.com/ru/привет",
      learnMoreUrl: "https://language.example.com/learn/russian/basic-greetings"
    }
  },
  "Show me nearby restaurants with good reviews": {
    tool: 'location_search',
    input: { 
      query: "restaurants", 
      location: "near_me",
      filter: "rating > 4" 
    },
    output: { 
      results: [
        { 
          name: "Cafe Pushkin", 
          rating: 4.8, 
          cuisine: "Russian", 
          price: "₽₽₽", 
          distance: "0.8 km", 
          address: "Tverskoy Blvd, 26А", 
          open_now: true,
          website: "https://cafe-pushkin.example.com",
          reserveUrl: "https://reservations.example.com/cafe-pushkin",
          menuUrl: "https://menus.example.com/cafe-pushkin",
          reviewsUrl: "https://reviews.example.com/cafe-pushkin"
        },
        { 
          name: "White Rabbit", 
          rating: 4.7, 
          cuisine: "Modern European", 
          price: "₽₽₽₽", 
          distance: "1.2 km", 
          address: "Smolenskaya Sq, 3", 
          open_now: true,
          website: "https://white-rabbit.example.com",
          reserveUrl: "https://reservations.example.com/white-rabbit",
          menuUrl: "https://menus.example.com/white-rabbit",
          reviewsUrl: "https://reviews.example.com/white-rabbit"
        },
        { 
          name: "Mari Vanna", 
          rating: 4.5, 
          cuisine: "Russian", 
          price: "₽₽", 
          distance: "1.5 km", 
          address: "Spiridonievskiy Ln, 10А", 
          open_now: true,
          website: "https://mari-vanna.example.com",
          reserveUrl: "https://reservations.example.com/mari-vanna",
          menuUrl: "https://menus.example.com/mari-vanna",
          reviewsUrl: "https://reviews.example.com/mari-vanna"
        },
        { 
          name: "Sakhalin", 
          rating: 4.6, 
          cuisine: "Seafood", 
          price: "₽₽₽₽", 
          distance: "2.1 km", 
          address: "Smolenskaya St, 8", 
          open_now: false,
          website: "https://sakhalin.example.com",
          reserveUrl: "https://reservations.example.com/sakhalin",
          menuUrl: "https://menus.example.com/sakhalin",
          reviewsUrl: "https://reviews.example.com/sakhalin"
        }
      ],
      current_location: "Moscow City Center",
      query_time: "2024-04-17T15:45:20Z",
      total_matches: 24,
      viewMoreUrl: "https://restaurants.example.com/moscow/top-rated",
      filterByUrl: "https://restaurants.example.com/moscow/filter",
      trendingUrl: "https://restaurants.example.com/moscow/trending"
    }
  }
};

// Initial responses for each tool type
export const initialResponses: Record<string, string> = {
  weather_forecast: "I'll check the weather in Moscow for you...",
  news_search: "Looking up the latest cryptocurrency news...",
  taxi_booking: "Let me book a taxi for you...",
  translator: "Translating to Russian...",
  location_search: "Searching for restaurants near you..."
};

// Response templates for each tool type
export const responseTemplates: Record<string, string> = {
  weather_forecast: `*Weather forecast for Moscow* 🌤️\n\n{forecast}\n\n📊 Data from: {location} (Updated today)\n\n<a href="{weatherMapUrl}" class="text-[#5cadec] underline" target="_blank">📍 View Weather Map</a> | <a href="{hourlyForecastUrl}" class="text-[#5cadec] underline" target="_blank">⏱️ Hourly Forecast</a> | <a href="{alertsUrl}" class="text-[#5cadec] underline" target="_blank">⚠️ Weather Alerts</a>`,
  
  news_search: `*Latest cryptocurrency news* 📰\n\n{articles}\n\n💬 Would you like me to summarize any of these articles?\n\n<a href="{trendingUrl}" class="text-[#5cadec] underline" target="_blank">📈 Trending in Crypto</a> | <a href="{marketDataUrl}" class="text-[#5cadec] underline" target="_blank">💹 Live Market Data</a> | <a href="{alertSetupUrl}" class="text-[#5cadec] underline" target="_blank">🔔 Set News Alerts</a>`,
  
  taxi_booking: `*Your taxi is booked!* 🚕✅\n\n*Booking details:*\n• 🕙 Pickup: Tomorrow at 10:00 AM from your home address\n• 🏢 Destination: {destination}\n• 🚘 Car type: {car_type}\n• 💰 Est. price: {estimated_price}\n• ⏱️ Est. travel time: {estimated_travel_time}\n\n🆔 *Booking reference:* {booking_id}\n\n📱 You'll receive driver details 15 minutes before pickup.\n\n<a href="{trackingUrl}" class="text-[#5cadec] underline" target="_blank">📍 Track Your Ride</a> | <a href="{cancelUrl}" class="text-[#5cadec] underline" target="_blank">❌ Cancel Booking</a> | <a href="{airportInfoUrl}" class="text-[#5cadec] underline" target="_blank">✈️ Airport Information</a>`,
  
  translator: `*Translation to Russian:* 🇷🇺\n\n"{translated_text}"\n\n🗣️ *Phonetic:* {phonetic}\n\n💡 This is an informal greeting. For a more formal situation, you could say:\n"{alternates[1]}"\n\n<a href="{pronunciationUrl}" class="text-[#5cadec] underline" target="_blank">🔊 Hear Pronunciation</a> | <a href="{dictionaryUrl}" class="text-[#5cadec] underline" target="_blank">📚 Dictionary</a> | <a href="{learnMoreUrl}" class="text-[#5cadec] underline" target="_blank">📝 Learn More Phrases</a>`,
  
  location_search: `*Found {results.length} highly-rated restaurants near you!* 🍽️\n\n{results}\n\n📝 Would you like more details about any of these restaurants?\n\n<a href="{viewMoreUrl}" class="text-[#5cadec] underline" target="_blank">🔍 View More Restaurants</a> | <a href="{filterByUrl}" class="text-[#5cadec] underline" target="_blank">🔎 Filter Results</a> | <a href="{trendingUrl}" class="text-[#5cadec] underline" target="_blank">🔥 Trending Places</a>`
};

// Helper function to convert URLs to HTML anchor tags
const convertUrlsToLinks = (text: string): string => {
  // Skip conversion if the text already contains HTML tags
  if (/<a\s+href/.test(text)) {
    return text;
  }
  
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Replace URLs with HTML anchor tags
  return text.replace(urlRegex, '<a href="$1" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">$1</a>');
};

// Helper function for formatting response templates with data
export const formatResponseFromTemplate = (template: string, data: any, toolType: string): string => {
  let formattedResponse = template;
  
  switch(toolType) {
    case 'weather_forecast': {
      const location = data.location || 'your location';
      
      const forecastText = data.forecast && Array.isArray(data.forecast) 
        ? data.forecast.map((day: any) => {
            // Choose appropriate emoji based on weather condition
            let weatherEmoji = '🌧️';
            if (day.condition === 'Sunny') weatherEmoji = '☀️';
            else if (day.condition === 'Partly Cloudy') weatherEmoji = '🌤️';
            else if (day.condition === 'Cloudy') weatherEmoji = '☁️';
            else if (day.condition.includes('Rain')) weatherEmoji = '🌧️';
            else if (day.condition.includes('Snow')) weatherEmoji = '❄️';
            
            return `*${day.day}:* ${weatherEmoji} ${day.condition}, *${day.high}°C*/${day.low}°C, ${day.precipitation} chance of rain`;
          }).join('\n') 
        : 'Forecast data unavailable';
      
      formattedResponse = template
        .replace('{forecast}', forecastText)
        .replace('{location}', location)
        .replace('{weatherMapUrl}', data.weatherMapUrl || 'https://weather.example.com/map')
        .replace('{hourlyForecastUrl}', data.hourlyForecastUrl || 'https://weather.example.com/hourly')
        .replace('{alertsUrl}', data.alertsUrl || 'https://weather.example.com/alerts');
      break;
    }
    
    case 'news_search': {
      const articlesText = data.articles && Array.isArray(data.articles)
        ? data.articles.map((article: any, index: number) => {
            // Create a shortened URL for display
            const url = article.url;
            const displayUrl = url.length > 30 ? url.substring(0, 30) + '...' : url;
            
            // Create a hyperlinked URL
            const linkedUrl = `<a href="${url}" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">${displayUrl}</a>`;
            
            return `${index + 1}. *${article.title}*\n   📰 Source: ${article.source} | ⏰ ${article.published}\n   🔗 ${linkedUrl}`;
          }).join('\n\n')
        : 'No articles available';
      
      formattedResponse = template
        .replace('{articles}', articlesText)
        .replace('{trendingUrl}', data.trendingUrl || 'https://news.example.com/trending')
        .replace('{marketDataUrl}', data.marketDataUrl || 'https://markets.example.com/live')
        .replace('{alertSetupUrl}', data.alertSetupUrl || 'https://alerts.example.com/setup');
      break;
    }
    
    case 'taxi_booking': {
      formattedResponse = template
        .replace('{destination}', data.destination || 'your destination')
        .replace('{car_type}', data.car_type || 'Standard')
        .replace('{estimated_price}', data.estimated_price || 'Price unavailable')
        .replace('{estimated_travel_time}', data.estimated_travel_time || 'Time unavailable')
        .replace('{booking_id}', data.booking_id || 'Booking ID unavailable')
        .replace('{trackingUrl}', data.trackingUrl || 'https://taxi.example.com/track')
        .replace('{cancelUrl}', data.cancelUrl || 'https://taxi.example.com/cancel')
        .replace('{airportInfoUrl}', data.airportInfoUrl || 'https://airport.example.com/info');
      break;
    }
    
    case 'translator': {
      const alternateText = data.alternates && Array.isArray(data.alternates) && data.alternates.length > 1 
        ? data.alternates[1] 
        : '';
      
      formattedResponse = template
        .replace('{translated_text}', data.translated_text || 'Translation unavailable')
        .replace('{phonetic}', data.phonetic || 'Phonetic unavailable')
        .replace('{alternates[1]}', alternateText)
        .replace('{pronunciationUrl}', data.pronunciationUrl || 'https://translate.example.com/pronounce')
        .replace('{dictionaryUrl}', data.dictionaryUrl || 'https://dictionary.example.com')
        .replace('{learnMoreUrl}', data.learnMoreUrl || 'https://language.example.com/learn');
      break;
    }
    
    case 'location_search': {
      const resultsLength = data.results && Array.isArray(data.results) ? data.results.length : 0;
      
      const resultsText = data.results && Array.isArray(data.results)
        ? data.results.map((place: any, index: number) => {
            // Links for each restaurant
            const websiteLink = place.website ? 
              `\n   🌐 <a href="${place.website}" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">Website</a>` : '';
            
            const reserveLink = place.reserveUrl ? 
              ` • <a href="${place.reserveUrl}" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">Reserve</a>` : '';
            
            const menuLink = place.menuUrl ? 
              ` • <a href="${place.menuUrl}" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">Menu</a>` : '';
            
            const reviewsLink = place.reviewsUrl ? 
              ` • <a href="${place.reviewsUrl}" class="text-[#5cadec] underline" target="_blank" rel="noopener noreferrer">Reviews</a>` : '';
            
            return `${index + 1}. *${place.name}* - ⭐ ${place.rating}\n   🍴 ${place.cuisine || 'Various cuisine'} • 💰 ${place.price || '$'} • 📍 ${place.distance || 'nearby'}\n   🏠 ${place.address || 'Address unavailable'} • ${place.open_now ? '🟢 Open now' : '🔴 Closed'}${websiteLink}${reserveLink}${menuLink}${reviewsLink}`;
          }).join('\n\n')
        : 'No restaurants available';
      
      formattedResponse = template
        .replace('{results.length}', resultsLength.toString())
        .replace('{results}', resultsText)
        .replace('{viewMoreUrl}', data.viewMoreUrl || 'https://restaurants.example.com/more')
        .replace('{filterByUrl}', data.filterByUrl || 'https://restaurants.example.com/filter')
        .replace('{trendingUrl}', data.trendingUrl || 'https://restaurants.example.com/trending');
      break;
    }
  }
  
  // Convert any remaining plain URLs to hyperlinks
  return convertUrlsToLinks(formattedResponse);
};
